import { handleActions } from 'redux-actions';
import actions from '../actions';

const {
  toggle,
  close,
  type: { change },
} = actions.scanner;

export default handleActions(
  {
    [close]: state => ({ ...state, active: false }),
    [toggle]: state => ({ ...state, active: !state.active }),
    [change]: (state, { payload: { type } }) => {
      window.localStorage.setItem('scannerType', type);
      return { ...state, type };
    },
  },
  {
    active: false,
    type: window.localStorage.getItem('scannerType'),
  }
);



// WEBPACK FOOTER //
// ./src/reducers/scanner.js